var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 48,
    viewBox: "0 0 43 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.79875 2.81177C-2.38419e-07 5.62356 0 10.149 0 19.2V28.8C0 37.8509 -2.38419e-07 42.3766 2.79875 45.1882C5.59752 48 10.102 48 19.1111 48H23.8889C32.8979 48 37.4026 48 40.2012 45.1882C43 42.3766 43 37.8509 43 28.8V19.2C43 10.149 43 5.62356 40.2012 2.81177C37.4026 2.38419e-07 32.8979 0 23.8889 0H19.1111C10.102 0 5.59752 2.38419e-07 2.79875 2.81177ZM10.1528 14.4C10.1528 13.4059 10.9549 12.6 11.9444 12.6H31.0556C32.045 12.6 32.8472 13.4059 32.8472 14.4C32.8472 15.3941 32.045 16.2 31.0556 16.2H11.9444C10.9549 16.2 10.1528 15.3941 10.1528 14.4ZM10.1528 24C10.1528 23.0059 10.9549 22.2 11.9444 22.2H31.0556C32.045 22.2 32.8472 23.0059 32.8472 24C32.8472 24.9941 32.045 25.8 31.0556 25.8H11.9444C10.9549 25.8 10.1528 24.9941 10.1528 24ZM11.9444 31.8C10.9549 31.8 10.1528 32.6059 10.1528 33.6C10.1528 34.5941 10.9549 35.4 11.9444 35.4H23.8889C24.8784 35.4 25.6806 34.5941 25.6806 33.6C25.6806 32.6059 24.8784 31.8 23.8889 31.8H11.9444Z",
    fill: "#73C7A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.07e5354ff010ab1881720262b22ccf1e.svg";
export { ForwardRef as ReactComponent };